import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
type Props = {
  result: any;
  onClick?: (val: string) => void;
  style?: any;
  hideIcon?: boolean;
  iconSx?: any;
  className?: string;
  index?: number;
};

const Chip = ({
  result,
  onClick,
  style,
  hideIcon,
  iconSx,
  className,
  index,
}: Props) => {
  const handleClick = () => {
    if (onClick) {
      onClick(result); // Call the onClick prop with the result as argument
    }
  };
  return (
    <div
      className={`${className} rounded-full w-fit py-[0.6rem] px-4 flex items-center bg-overlay-mid border border-edge`}
      style={style}
    >
      <p className="text-xs font-medium mr-2 text-text-primary">
        {result}
      </p>
      {hideIcon ? null : (
        <FontAwesomeIcon
          icon={faClose}
          onClick={handleClick}
          className="w-3 text-lg h-3 text-light-gray cursor-pointer hover:text-ilara-red transition-colors"
        />
      )}
    </div>
  );
};

export default Chip;
